import React, { createContext, useCallback, useContext } from 'react';
import { LoginModal } from '../components/login-modal';
import { openLoginModal } from '../utils';
export const AuthContext = createContext(null);
/**
 * Provider for the authentication context.
 *
 * @param {React.ReactNode} children - The children to render within the provider.
 * @param {string} authUrl - The URL used for user authentication.
 * @param {HttpClientT<unknown>} httpClient - A function for making HTTP requests, which takes an optional URL and request options, and returns a promise with the result.
 * @param {(value: boolean) => void} setIsLogged - Function to update the login state of the component. Accepts a boolean value indicating whether the user is logged in.
 */
export function AuthProvider({ children, authUrl, httpClient }) {
    const connect = useCallback((configurationId) => {
        openLoginModal(configurationId);
    }, []);
    return (React.createElement(AuthContext.Provider, { value: { connect } },
        children,
        React.createElement(LoginModal, { authUrl: authUrl, httpClient: httpClient })));
}
export const useAuthContext = () => {
    const context = useContext(AuthContext);
    if (!context) {
        return null;
    }
    return context;
};
